
import { FC, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Languages } from './Languages'
import { KTIcon } from '../../../helpers/components/KTIcon'
import { toAbsoluteUrl } from '../../../helpers/AssetHelpers'
import { Helpers } from '../../../../helpers/Helpers'
import ExpireStorage from '../../../../helpers/ExpireStorage'
import { useDispatch } from 'react-redux'
import { storeUser } from '../../../../redux/reducers/authSlice'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../redux/store'
import SifreDegistirModal from '../../../../modals/SifreDegistirModal'

const HeaderUserMenu: FC = () => {
    const auth = useSelector((state: RootState) => state.auth)
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [sifrePenceresi, setSifrePenceresi] = useState(false);

    // const [currentUser, setCurrentUser] = useState({
    //     first_name: 'berke',
    //     email: 'berkeelm@gmail.com'
    // })

    const logout = async () => {
        await ExpireStorage.removeItem(Helpers.getStorageKeys()[0]);
        await ExpireStorage.removeItem(Helpers.getStorageKeys()[1]);
        localStorage.removeItem(Helpers.getStorageKeys()[4])
        localStorage.removeItem(Helpers.getStorageKeys()[5])
        localStorage.removeItem("SelectedCompanyId");
        navigate('/')
        dispatch(storeUser({ isLoading: false, user: undefined }))
    }

    return (
        <div
            className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
            data-kt-menu='true'
        >
            <div className='menu-item px-3'>
                <div className='menu-content d-flex align-items-center px-3'>
                    <div className='symbol symbol-50px me-5'>
                        <img alt='Logo' src={Helpers.getPlaceholder()} />
                    </div>

                    <div className='d-flex flex-column'>
                        <div className='fw-bolder d-flex align-items-center fs-5'>
                            {auth.user.user?.data.nameSurname}
                            {/* <span className='badge badge-light-success fw-bolder fs-8 px-2 py-1 ms-2'>Pro</span> */}
                        </div>
                        <a href='#' className='fw-bold text-muted text-hover-primary fs-7'>
                            {auth.user.user?.data.email}
                        </a>
                    </div>
                </div>
            </div>

            <div className='separator my-2'></div>

            {/* <div className='menu-item px-5'>
                <Link to={'/crafted/pages/profile'} className='menu-link px-5'>
                    My Profile
                </Link>
            </div>

            <div className='menu-item px-5'>
                <a href='#' className='menu-link px-5'>
                    <span className='menu-text'>My Projects</span>
                    <span className='menu-badge'>
                        <span className='badge badge-light-danger badge-circle fw-bolder fs-7'>3</span>
                    </span>
                </a>
            </div> */}

            {/* <div
                className='menu-item px-5'
                data-kt-menu-trigger='hover'
                data-kt-menu-placement='left-start'
                data-kt-menu-flip='bottom'
            >
                <a href='#' className='menu-link px-5'>
                    <span className='menu-title'>My Subscription</span>
                    <span className='menu-arrow'></span>
                </a>

                <div className='menu-sub menu-sub-dropdown w-175px py-4'>
                    <div className='menu-item px-3'>
                        <a href='#' className='menu-link px-5'>
                            Referrals
                        </a>
                    </div>

                    <div className='menu-item px-3'>
                        <a href='#' className='menu-link px-5'>
                            Billing
                        </a>
                    </div>

                    <div className='menu-item px-3'>
                        <a href='#' className='menu-link px-5'>
                            Payments
                        </a>
                    </div>

                    <div className='menu-item px-3'>
                        <a href='#' className='menu-link d-flex flex-stack px-5'>
                            Statements
                            <i
                                className='fas fa-exclamation-circle ms-2 fs-7'
                                data-bs-toggle='tooltip'
                                title='View your statements'
                            ></i>
                        </a>
                    </div>

                    <div className='separator my-2'></div>

                    <div className='menu-item px-3'>
                        <div className='menu-content px-3'>
                            <label className='form-check form-switch form-check-custom form-check-solid'>
                                <input
                                    className='form-check-input w-30px h-20px'
                                    type='checkbox'
                                    value='1'
                                    defaultChecked={true}
                                    name='notifications'
                                />
                                <span className='form-check-label text-muted fs-7'>Notifications</span>
                            </label>
                        </div>
                    </div>
                </div>
            </div> */}

            {/* <div className='menu-item px-5'>
                <a href='#' className='menu-link px-5'>
                    My Statements
                </a>
            </div> */}

            {/* <div className='separator my-2'></div> */}

            {/* <Languages /> */}

            {/* <div className='menu-item px-5 my-1'>
                <Link to='/crafted/account/settings' className='menu-link px-5'>
                    Account Settings
                </Link>
            </div> */}

            <div className='menu-item px-5'>
                <a onClick={() => setSifrePenceresi(true)} className='menu-link px-5'>
                    Şifremi Değiştir
                </a>
            </div>

            <div className='menu-item px-5'>
                <a onClick={logout} className='menu-link px-5'>
                    Çıkış Yap
                </a>
            </div>

            <SifreDegistirModal
                isShown={sifrePenceresi}
                onClose={() => setSifrePenceresi(false)}
                onChanged={() => { setSifrePenceresi(false); logout(); }}
            />
        </div >
    )
}

export { HeaderUserMenu }
